<template>
  <div class="is-concurrent">
    <label class="has-text-weight-bold has-text-grid-1 is-size-14px">
      Concurrence ({{ getNbreConcurrents }})
    </label>
    <div class="pl-30 pr-30">
      <b-slider
        :value="rayon"
        :min="constantes.rayonMin"
        :max="constantes.rayonMax"
        :step="constantes.rayonStep"
        :custom-formatter="(val) => val + 'km'"
        @change="rayon = $event"
        tooltip/>
    </div>
    <div class="displayScrollable">
      <concurrent-collapse
        v-for="secteur in getConcurrents"
        :key="secteur.id"
        :donnee="secteur"
        @check="actionCheckSecteur(secteur)"
        class-libelle="has-text-weight-bold"
        :default-open="secteur.openSecteur">
        <concurrent-collapse
          v-for="(marque, index) in secteur.children"
          :key="index"
          :donnee="marque"
          @check="actionCheckMarque(marque, secteur)">
          <concurrent-collapse
            v-for="pdv in marque.children ? marque.children : []"
            :key="pdv.id"
            :donnee="pdv"
            @check="actionCheckPdv(marque, secteur)">
          </concurrent-collapse>
        </concurrent-collapse>
      </concurrent-collapse>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as Config from '@/configurations/configurationCarto';
import * as types from '@/store/modules/recommandation-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import ConcurrentCollapse from '@/components/portail/concurrent/concurrentCollapse';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: {
    ConcurrentCollapse,
  },
  data() {
    return {
      constantes: {
        rayonMin: Config.RAYON_MIN,
        rayonMax: Config.RAYON_MAX,
        rayonStep: Config.RAYON_STEP,
      },
      openSecteur: true,
    };
  },
  watch: {
    rayon() {
      this.loadConcurrents();
    },
  },
  computed: {
    ...Recommandation.mapGetters({
      getRayon: 'rayon',
      getConcurrents: 'concurrents',
      getNbreConcurrents: 'nbreConcurrents',
    }),
    rayon: {
      get() {
        return this.getRayon;
      },
      set(value) {
        this.setFilterRayon(value);
      },
    },
  },
  methods: {
    ...Recommandation.mapMutations({
      setFilterRayon: types.SET_FILTER_RAYON,
    }),
    ...Recommandation.mapActions({
      actionsRecupererConcurrents: 'recupererConcurrents',
    }),
    async loadConcurrents() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await this.actionsRecupererConcurrents();
        loadingComponent.close();
      } catch (error) {
        gestionErreur('Erreur lors de la récupération des concurrents', error);
        loadingComponent.close();
      }
    },
    actionCheckSecteur(secteur) {
      secteur.children.forEach(marque => {
        marque.selected = secteur.selected;
        marque.children.forEach(el => {
          el.selected = marque.selected;
        });
      });
    },
    actionCheckMarque(marque, secteur) {
      marque.children.forEach(el => {
        el.selected = marque.selected;
      });
      secteur.selected = secteur.children.every(el => el.selected);
    },
    actionCheckPdv(marque, secteur) {
      marque.selected = marque.children.every(el => el.selected);
      secteur.selected = secteur.children.every(el => el.selected);
    }
  },
  async mounted() {
    await this.loadConcurrents();
  },
};
</script>

<style>

</style>
